/* eslint-disable no-empty */
import {
  ResponseBasketballGetGameUpdates,
  ResponseBasketballGetPracticeUpdates,
} from '@hefe/models';
import { createApi } from '@reduxjs/toolkit/query/react';
import API from '../../../api/api';

export const notificationsApi = createApi({
  reducerPath: 'apiNotifications',
  baseQuery: API.baseQuery,
  endpoints: (builder) => ({
    /**************************************************************************
     *                              BASKETBALL
     *************************************************************************/
    fetchBasketballPracticesUpdates: builder.query<
      ResponseBasketballGetPracticeUpdates,
      string
    >({
      query: (request) =>
        `v2/user/notifications/${request}/basketball-practices-updates`,
    }),
    fetchBasketballGamesUpdates: builder.query<
      ResponseBasketballGetGameUpdates,
      string
    >({
      query: (request) =>
        `v2/user/notifications/${request}/basketball-games-updates`,
    }),
  }), // end of endpoints
});

// Export hooks for usage in functional components
export const {
  useFetchBasketballPracticesUpdatesQuery,
  useFetchBasketballGamesUpdatesQuery,
  reducerPath,
  reducer,
  middleware,
} = notificationsApi;
